import { z } from 'zod';

export const PackageWalletSettlementSchema = z.object({
  package_ids: z.array(z.string().uuid()).min(1),
  charged_amount: z.coerce.number().finite().nonnegative(),
  new_balance: z.coerce.number().finite().nonnegative(),
  payment_status: z.literal('wallet_paid'),
  idempotent: z.boolean().default(false),
});

export const PackageWalletRefundSchema = z.object({
  package_ids: z.array(z.string().uuid()).min(1),
  charged_amount: z.coerce.number().finite().nonnegative(),
  new_balance: z.coerce.number().finite().nonnegative(),
  payment_status: z.literal('refunded'),
  idempotent: z.boolean().default(false),
});

export type PackageWalletSettlement = z.infer<
  typeof PackageWalletSettlementSchema
>;

export type PackageWalletRefund = z.infer<typeof PackageWalletRefundSchema>;

export interface PackageWalletPlayerDetail {
  name: string;
  phone: string;
}

export function parsePackageWalletSettlement(value: unknown) {
  return PackageWalletSettlementSchema.parse(value);
}

export function parsePackageWalletRefund(value: unknown) {
  return PackageWalletRefundSchema.parse(value);
}

export function canPayPackageWithWallet(
  isAuthenticated: boolean,
  isAuthorizedPayer: boolean,
  walletEnabled: boolean,
  walletBalance: number,
  amount: number,
  alreadyPaidAmount = 0,
) {
  return (
    isAuthenticated &&
    isAuthorizedPayer &&
    walletEnabled &&
    alreadyPaidAmount === 0 &&
    Number.isFinite(amount) &&
    amount > 0 &&
    Number.isFinite(walletBalance) &&
    walletBalance + 0.00001 >= amount
  );
}
